export default "__VITE_ASSET__CgMzOo5___"